import { createContext, useContext } from "react";
import { PluginHandler } from "../../Connectors/Shared/PluginHandler";

interface IPluginHandlerContext {
    plugin?: PluginHandler;
}

export const PluginHandlerContext = createContext<IPluginHandlerContext>({});
export const usePluginHandler = () => useContext(PluginHandlerContext);
